export default __webpack_public_path__ + "static/media/logo_surrogate.fd5f6465.svg";